import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Formik, Field as Fieldmik } from 'formik';
import { Form as FormUi, Segment, Button } from 'semantic-ui-react';
import * as yup from 'yup';

import AddTitleBar from '../../titleBar/addTitleBar';
import LoadingPlaceholder from '../../placeholder/loadingPlaceholder';
import { updateBillingParty, getBillingParty, getBillingPartyBranch } from '../../../redux/actions/billingPartyActions';

import BranchTable from './branchTable';
import { MyNormalInput } from '../../formikInput/input';
import {
    ADDRESS_REQUIRED, CUSTUMER_CODE_REQUIRED,
    CUSTUMER_NAME_REQUIRED, INVALID_PAN_NO, PINCODE_REQUIRED
} from '../../../config/const';
import { AllRegex } from '../../../utils/validation';

const EditBillingParty = (props) => {

    const { updateBillingParty, getBillingParty, getBillingPartyBranch,
        billingPartyLoading, billingPartyData, billingPartyBranchData } = props;

    useEffect(() => {
        const id = props.location.state.id;
        getBillingParty(id);
        getBillingPartyBranch(id);
    }, [])

    if (billingPartyLoading) {
        return (
            <React.Fragment>
                <LoadingPlaceholder />
            </React.Fragment>
        )
    } else {
        const id = props.location.state.id;

        const initialValues = {
            customerCode: billingPartyData ? billingPartyData[0].billingPartyCode : '',
            customerCompanyName: billingPartyData ? billingPartyData[0].billingPartyName : '',
            customerContactName: billingPartyData ? billingPartyData[0].billingPartyContactPerson : '',
            customerContactNumber: billingPartyData ? billingPartyData[0].billingPartyContactPersonNumber : '',
            customerAddress: billingPartyData ? billingPartyData[0].billingPartyAddress : '',
            pincode: billingPartyData ? billingPartyData[0].billingPartyPincodeNo : '',
            panNumber: billingPartyData ? billingPartyData[0].panNumber : ''
        }

        const validateSchema = yup.object().shape({
            customerCode: yup.mixed().required(CUSTUMER_CODE_REQUIRED),
            customerCompanyName: yup.mixed().required(CUSTUMER_NAME_REQUIRED),
            customerAddress: yup.mixed().required(ADDRESS_REQUIRED),
            pincode: yup.mixed().required(PINCODE_REQUIRED),
            panNumber: yup.string().optional().matches(AllRegex.PANIN, INVALID_PAN_NO).nullable()
        })

        const onSubmit = (values, onSubmitProps) => {

            const customerNumber = localStorage.getItem('customerNo');
            const userId = localStorage.getItem('userId');

            const updateCustomerData = {
                customerNo: customerNumber,
                userId: userId,
                billingPartyAddress: values.customerAddress,
                billingPartyPincodeNo: values.pincode,
                customerNumber: customerNumber,
                industrySegmentId: "1",
                customer_no: customerNumber,
                billingPartyCode: values.customerCode,
                billingPartyContactPerson: values.customerContactName,
                billingPartyContactPersonNumber: values.customerContactNumber,
                billingPartyName: values.customerCompanyName,
                panNumber: values.panNumber,
                user_id: userId
            };

            updateBillingParty(updateCustomerData, id).then(() => {
                setTimeout(() => { onSubmitProps.setSubmitting(false) }, 4000)
            });
        };

        return (
            <React.Fragment>
                <AddTitleBar title="Edit Customer" LinkName="/billingparty" />
                <div className="m-2">
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validateSchema}
                        onSubmit={onSubmit}
                    >
                        {({ touched, errors, values, isSubmitting, handleSubmit }) => (
                            <>
                                <Segment>
                                    <div className="ui form tiny">
                                        <FormUi.Group >
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Customer Code *</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik name="customerCode" placeholder="Type Code" />
                                                {touched.customerCode && errors.customerCode ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.customerCode}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Customer Company Name *</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik name="customerCompanyName" placeholder="Type Name" />
                                                {touched.customerCompanyName && errors.customerCompanyName ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.customerCompanyName}</strong> : ''}
                                            </FormUi.Field>
                                        </FormUi.Group>
                                        <FormUi.Group >
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Contact Person Name</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik name="customerContactName" placeholder="Enter Contact Person Name" />
                                                {touched.customerContactName && errors.customerContactName ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.customerContactName}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Contact Person Number</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik name="customerContactNumber" placeholder="Enter Contact Person Number" />
                                                {touched.customerContactNumber && errors.customerContactNumber ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.customerContactNumber}</strong> : ''}
                                            </FormUi.Field>
                                        </FormUi.Group>
                                        <FormUi.Group >
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Customer Address *</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik name="customerAddress" placeholder="Enter Address" />
                                                {touched.customerAddress && errors.customerAddress ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.customerAddress}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Pincode *</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik name="pincode" placeholder="Enter Pincode" />
                                                {touched.pincode && errors.pincode ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.pincode}</strong> : ''}
                                            </FormUi.Field>
                                        </FormUi.Group>
                                        <FormUi.Group >
                                            <FormUi.Field width={3}>
                                                <label className="labelName">Pan Number</label>
                                            </FormUi.Field>
                                            <FormUi.Field width={4}>
                                                <Fieldmik
                                                    component={MyNormalInput}
                                                    size='mini'
                                                    name='panNumber'
                                                    value={values.panNumber}
                                                    type='text'
                                                    placeholder='Please Enter Pan No.'
                                                />
                                                {touched.panNumber && errors.panNumber ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.panNumber}</strong> : ''}
                                            </FormUi.Field>
                                        </FormUi.Group>
                                    </div>
                                </Segment>

                                <center><Button disabled={isSubmitting} onClick={handleSubmit} size='mini' primary type='submit'>Submit</Button></center>
                            </>
                        )}
                    </Formik>
                    <Segment>
                        <div className="ui form tiny">
                            <BranchTable billingPartyBranchData={billingPartyBranchData} customerId={id} />
                        </ div>
                    </Segment>
                    {/* <Segment>
                        <UserTable vendorId={id}   />
                    </Segment>
                    <Segment>
                        <VehicleTable vendorId={id}  />
                    </Segment> */}
                </div>
            </React.Fragment>
        )
    }
}

const mapStatetoProps = state => ({
    billingPartyData: state.getBillingPartyData.billingParty.resultSet,
    billingPartyLoading: state.getBillingPartyData.isLoading,
    billingPartyBranchData: state.getBillingPartyBranchData.billingPartyMaster.resultSet,
    billingPartyBranchLoading: state.getBillingPartyBranchData.isLoading,
    panNumber: state.getBillingPartyData.billingParty.resultSet
})

export default connect(mapStatetoProps, { updateBillingParty, getBillingParty, getBillingPartyBranch })(EditBillingParty)
